import _get from 'lodash/get';

interface CompaniesMakersListItem {
  id: string | number;
  srno: number;
  shortName: string;
  maker: string;
  status: string;
  actions: string;
}

interface CompaniesMakersApiParser {
  CompaniesMakersListParser: (_res: any) => CompaniesMakersListItem[];
}

const companiesMakersApiParser: CompaniesMakersApiParser = {
  CompaniesMakersListParser: (_res: unknown): CompaniesMakersListItem[] => {
    const content = _get(_res, 'data.content', []) as any[];

    if (Array.isArray(content) && content.length > 0) {
      return content.map((itm, idx) => ({
        id: _get(itm, 'makerId', 0),
        srno: Number(_get(itm, 'makerId', idx + 1)),
        shortName: _get(itm, 'shortName', ''),
        maker: _get(itm, 'companyName', ''),
        status: _get(itm, 'active', false) ? 'Active' : 'Inactive',
        actions: 'Edit',
      }));
    }

    return [];
  },
};

export default companiesMakersApiParser;

export interface CompaniesMakersItem {
  id: number;
  shortName: string;
  maker: string;
  status: string;
}

export interface CompaniesMakersData {
  companiesMakers: CompaniesMakersItem[];
  companies: { value: string; label: string }[];
  statusOptions: { value: string; label: string }[];
}
